import { useEffect, useRef } from "react";

export const LazyVideo = ({ src, poster, className }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (!el.getAttribute("src")) el.setAttribute("src", el.dataset.src);
          el.play().catch(() => {});
        } else {
          el.pause();
        }
      },
      { rootMargin: "300px" }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <video
      ref={ref}
      data-src={src}
      poster={poster}
      loop
      muted
      playsInline
      preload="none"
      className={className}
    />
  );
};
